module.exports = __webpack_public_path__ + "static/media/ks_swiper_c.3ab4cb1c.jpg";